<mat-sidenav-container color="primary">

    <mat-sidenav-content>
        <div fxLayout="column" class="mat-elevation-z1">
            <!-- <div style="margin-left: 30px;margin-right: 30px;" fxLayout="column" class="mat-elevation-z1"> -->
            <div>
                <mat-toolbar style="margin-top: 10px;" color="primary" fxFlex="100%" fxLayout="column">
                    <mat-toolbar-row fxLayoutAlign="center" fxLayout="column" fxFlex="100%">
                        <h2 fxFlexAlign="center">{{componentDisplayName}}</h2>

                        <mat-toolbar-row fxLayout="row" fxFlex="100%">
                            <!-- <button
                                 [disabled]="!(gdbValue || ((!fileUploadRequired || (fileUploadRequired && isFileUploaded)) && !isDataSaved && !componentDataEntryForm.invalid && componentDataEntryForm.dirty))"
                                 matTooltip="Save Details" mat-icon-button (click)="saveConfirmation()" style="font-size: 15px;">Save</button> -->
                            <!-- <button  *ngIf="gdbValue || (!fileUploadRequired || (fileUploadRequired && isFileUploaded)) && !isDataSaved && !componentDataEntryForm.invalid && componentDataEntryForm.dirty" matTooltip="Save Details" mat-icon-button
                                (click)="saveConfirmation()"><mat-icon>save</mat-icon></button> -->
                            <button matTooltip="Delete Details" mat-icon-button
                                (click)="deleteButtonClicked()"><mat-icon>delete_forever</mat-icon></button>
                            <button matTooltip="Refresh" mat-icon-button
                                (click)="refreshButton()">Refresh</button>
                            <div fxFlex></div>

                            <button
                                [disabled]="!(gdbValue || ((!fileUploadRequired || (fileUploadRequired && isFileUploaded)) && !isDataSaved && !componentDataEntryForm.invalid && componentDataEntryForm.dirty))"
                                matTooltip="Save Details" mat-button (click)="saveConfirmation()"
                                [ngClass]="{ 'custom-button': true, 'disabled': !(gdbValue || ((!fileUploadRequired || (fileUploadRequired && isFileUploaded)) && !isDataSaved && !componentDataEntryForm.invalid && componentDataEntryForm.dirty)) }">
                                Save
                            </button>

                            <button mat-button [matMenuTriggerFor]="candidateDocsMenu">Uploaded Docs</button>

                        </mat-toolbar-row>

                    </mat-toolbar-row>
                </mat-toolbar>
                <mat-menu #candidateDocsMenu="matMenu">
                    <div *ngFor="let file of candidateDocuments" fxFlex="100%">
                        <div fxFlex="100%" style="padding: 5px;">
                            <span>{{file}}</span>
                            <button matTooltip="Open the file" fxFlex="15%;" mat-icon-button color="primary"
                                (click)="downloadCandidateDoc(file)"><mat-icon>download</mat-icon></button>
                            <button matTooltip="Delete the file" fxFlex="15%" mat-icon-button color="warn"
                                (click)="deleteCandidateDoc(file)"><mat-icon>delete</mat-icon></button>
                        </div>
                    </div>

                </mat-menu>
            </div>
            <div style="margin-top: 10px;" fxFlex="100%">
                <div style="display: flex; margin-bottom: 10px;margin-left: 10px;" *ngIf="statusInDb == 'CDE-REJECTED'">
                    <label style="margin-right: 10px;">Rejection Remarks : </label>
                    <textarea style="color:red; font-size: large; width:50%" readonly matInput cols="10" rows="1"
                        [(ngModel)]="inputqcComments" placeholder="Rejection Remarks"></textarea>
                </div>

                <div style="margin-bottom: 10px;margin-left: 10px;color:red; font-size: 1rem;">
                    Enter {{item.details}}
                </div>
                <form [formGroup]="componentDataEntryForm">
                    <mat-grid-list cols="3" rowHeight="70px">
                        <mat-grid-tile *ngFor="let componentField of componentFields">
                            <mat-form-field style="width:95%;margin-top: 15px;"
                                *ngIf="componentField.type=='TEXT' && (componentField.lhsRhs=='LHS' || componentField.lhsRhs == 'BOTH')"
                                appearance="outline">

                                <div *ngIf="componentField.value; else default">
                                    <input formControlName="{{componentField.name}}"
                                        required="{{componentField.mandatory}}" matInput size="30"
                                        [attr.maxlength]="getFieldSize(componentField)" type="text" ngDefaultControl
                                        [(ngModel)]="componentField.value" placeholder={{componentField.label}}>
                                </div>

                                <ng-template #default>
                                    <input formControlName="{{componentField.name}}" matInput size="30"
                                        [attr.maxlength]="getFieldSize(componentField)" type="text"
                                        placeholder={{componentField.label}}>
                                </ng-template>
                                <mat-label>{{componentField.label}}</mat-label>
                            </mat-form-field>
                            <mat-form-field style="width:95%;margin-top: 15px;"
                                *ngIf="componentField.type=='TEXTAREA' && (componentField.lhsRhs=='LHS' || componentField.lhsRhs=='BOTH')"
                                appearance="outline">
                                <textarea maxlength="{{componentField.size}}" rows="3" cols="30"
                                    formControlName="{{componentField.name}}" matInput size="30"
                                    [attr.maxlength]="getFieldSize(componentField)" type="text"
                                    placeholder={{componentField.label}}></textarea>
                                <mat-label>{{componentField.label}}</mat-label>
                            </mat-form-field>
                            <mat-form-field style="width:95%;margin-top: 15px;"
                                *ngIf="componentField.type=='SELECT' && (componentField.lhsRhs=='LHS' || componentField.lhsRhs=='BOTH')"
                                appearance="outline">
                                <mat-select formControlName="{{componentField.name}}">
                                    <ng-template ngFor let-val="$implicit" [ngForOf]="getValues(componentField.name)">
                                        <mat-option value={{val}}>{{val}}</mat-option>
                                    </ng-template>
                                </mat-select>
                                <mat-label>{{componentField.label}}</mat-label>
                            </mat-form-field>
                            <mat-form-field style="width:95%;margin-top: 15px;"
                                *ngIf="componentField.type=='DATE' && (componentField.lhsRhs=='LHS' || componentField.lhsRhs == 'BOTH')"
                                appearance="outline">
                                <input formControlName={{componentField.name}} required="{{componentField.mandatory}}"
                                    matInput size="11" maxlength="11" type="date" placeholder={{componentField.label}}>
                                <mat-label>{{componentField.label}}</mat-label>
                            </mat-form-field>
                        </mat-grid-tile>
                        <!-- <button type="submit"  mat-raised-button color="primary" style="color: white; width: 55px; height: 36px; border-radius: 9px; margin-bottom: 3px; text-align: center; position: absolute; right: 47px; top: 259px; "  *ngIf="(!fileUploadRequired || (fileUploadRequired && isFileUploaded)) && !isDataSaved && !componentDataEntryForm.invalid && componentDataEntryForm.dirty" matTooltip="Save Details" mat-icon-button
                (click)="saveConfirmation()">Save</button> -->
                        <!-- <button  [disabled]="personalDetailsDataEntryForm.invalid" matTooltip="Save Personal Details" mat-icon-button (click)="saveConfirmation()"> Save </button> -->

                    </mat-grid-list>
                    <ng-template [ngIf]="fileUploadRequired">
                        <fieldset style="margin-top: 10px;">
                            <legend style="background-color: black;color: white;">Upload Documents(if any)</legend>

                            <mat-form-field fxFlexOffset="20px" fxFlex="20%" appearance="outline">
                                <ngx-mat-file-input formControlName="componentFile" accept=".pdf"
                                    valuePlaceholder="Click to upload Candidate Doc"
                                    placeholder="Click to Upload Candidate Docs" (change)="onFileSelected($event)">
                                </ngx-mat-file-input>
                                <mat-label>Upload Documents</mat-label>
                            </mat-form-field>

                            <button
                                [disabled]="componentDataEntryForm.invalid || componentDataEntryForm.get('componentFile').value==''"
                                style="margin-top:10px;height:35px" mat-raised-button color="primary"
                                fxFlexOffset="20px" (click)="uploadFile()">Add</button><br><br>
                            <!-- <button mat-button [matMenuTriggerFor]="candidateDocsMenu" mat-raised-button color="primary"
                                style="height: 35px;margin-top:10px;  " fxFlexOffset="20px">Uploaded Docs</button> -->
                        </fieldset>
                    </ng-template>
                </form>

            </div>
        </div>
        <div style="padding:20px" *ngIf="statusInDb == 'CDE-REJECTED'">
            <mat-form-field appearance="outline">
                <textarea style="color:red" readonly matInput cols="30" rows="3" [(ngModel)]="inputqcComments"
                    placeholder="Rejection Remarks"></textarea>
                <mat-label>Rejection Remarks</mat-label>
            </mat-form-field>
        </div>
        <div *ngIf="showCandidateDocsDialog" cdkDrag
            style="padding:20px;position:absolute;left:20px;top:vh;width:800px;height:500px;background-color: white;"
            class="mat-elevation-z3">
            <div style="width:100%">
                <div fxFlex></div>
                <h3>{{displayedCandidateDocName}}</h3>
                <div fxFlex></div>
            </div>
            <ngx-extended-pdf-viewer height="50vh" [src]="candidateDocBlob"
                useBrowserLocale="false"></ngx-extended-pdf-viewer>
            <div class="mat-elevation-z3" fxLayoutAlign="center" style="margin-top: 15px;width: 100%;">
                <button fxFlexAlign="center" mat-raised-button color="primary"
                    (click)="closeCandidateDocsDialog()">Close</button>
            </div>
        </div>
        <!-- <div style="padding:20px" *ngIf="addressComponent">
            <p style="color:red">Please Upload the following documents in pdf format</p>
            <ol>
                <li>Rental/Lease Agreement</li>
                <li>Aadhaar Card</li>
                <li>Passport</li>
                <li>Voters ID</li>
                <li>Electricity Bill</li>
                <li>Postpaid Bill</li>
                <li>Driving License</li> 
            </ol>
        </div> -->
        <div style="padding:20px" *ngIf="gapvfnComponent">
            <p style="color:red">Please account for any and all GAPS between education and employment period greater
                than 30 days.</p>
            <p style="color:red">Please Upload the following documents in pdf format</p>
            <ol>
                <li>Rental/Lease Agreement</li>
                <li>Aadhaar Card</li>
                <li>Passport</li>
                <li>Voters ID</li>
                <li>Electricity Bill</li>
                <li>Postpaid Bill</li>
                <li>Driving License</li>
            </ol>
        </div>
        <!-- <div style="padding:20px" *ngIf="drugtestComponent">
            <p style="color:red">Please Upload the following documents in pdf format</p>
            <ol>
                <li>Drug Test Proof</li>
            </ol>
        </div> -->
        <div style="padding:20px" *ngIf="educationComponent">
            <p style="color:red">Please Upload the following documents in pdf format</p>
            <ol>
                <li>Degree Certificate</li>
                <li>All Semester Marksheets</li>
                <li>Provisional Certificate</li>
                <li>Consolidated Marksheets</li>
                <li>Course Completion Certificate</li>
            </ol>
        </div>
        <div style="padding-left:20px" *ngIf="employmentComponent">
            <p style="color:red">Please Upload the following documents in pdf format</p>
            <ol>
                <li>Relieving Letter</li>
                <li>Last Payslip</li>
                <li>Service/Experience Letter</li>
                <li>Appointment Letter</li>
            </ol>
        </div>
        <div style="padding-left:20px" *ngIf="identityComponent">
            <p style="color:red">Please Upload the following documents in pdf format</p>
            <ol>
                <li>PAN Card</li>
                <li>Aadhaar Card</li>
                <li>Driving License Card</li>
                <li>Voters ID</li>
                <li>Passport</li>

            </ol>
        </div>
        <div style="padding-left:20px" *ngIf="voterIdComponent">
            <p style="color:red">Please Upload the following documents in pdf format</p>
            <ol>
                <li>Copy of Voter ID</li>
            </ol>
        </div>
        <div style="padding-left:20px" *ngIf="panComponent">
            <p style="color:red">Please Upload the following documents in pdf format</p>
            <ol>
                <li>Copy of PAN</li>
            </ol>
        </div>
        <div style="padding-left:20px" *ngIf="passportComponent">
            <p style="color:red">Please Upload the following documents in pdf format</p>
            <ol>
                <li>Copy of Passport</li>
            </ol>
        </div>
        <div style="padding-left:20px" *ngIf="dlComponent">
            <p style="color:red">Please Upload the following documents in pdf format</p>
            <ol>
                <li>Copy of Driving License</li>
            </ol>
        </div>
        <div style="padding-left:20px" *ngIf="adharComponent">
            <p style="color:red">Please Upload the following documents in pdf format</p>
            <ol>
                <li>Copy of Adhaar</li>
            </ol>
        </div>
        <div style="padding-left:20px" *ngIf="bankStatementComponent">
            <p style="color:red">Please Upload the following documents in pdf format</p>
            <ol>
                <li>Copy of Bank Statment for the tenure mentioned</li>
            </ol>
        </div>
        <!-- <div style="padding-left:20px" *ngIf="globaldatabaseComponent">
            <p style="color:red">Please Upload the following documents in pdf format</p>
            <ol>
                <li>Copy of Government Approved ID</li>
            </ol>
        </div> -->

        <div class="container" *ngIf="gapDataForTable">

            <div class="table">
                <div class="table-header">
                    <div class="header__item"><a id="name" class="filter__link" href="#">Sl No.</a></div>
                    <div class="header__item"><a id="wins" class="filter__link filter__link--number" href="#">Period Of
                            Employment</a>
                    </div>
                    <div class="header__item"><a id="draws" class="filter__link filter__link--number"
                            href="#">Employment Gap (In Months)</a>
                    </div>
                </div>
                <div class="table-content">
                    <div class="table-row" *ngFor="let item of gapDataForTable;">
                        <div class="table-data">{{item.serialNumber}}</div>
                        <div class="table-data"><strong>{{item.from}}</strong> - <strong>{{item.to}}</strong></div>
                        <div class="table-data">{{item.gap}}</div>
                    </div>

                </div>
            </div>
        </div>
    </mat-sidenav-content>

</mat-sidenav-container>